import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  ITEM_GROUP_CLASS,
  ITEM_GROUP_DEFAULTS,
  TItemGroupProps,
} from "@/ui/components/data-display/Item/Item.config";

export const ItemGroup: FC<TItemGroupProps> = (
  {
    "data-component": component = ITEM_GROUP_DEFAULTS["data-component"],
    className,
    children,
    ...props
  },
) => (
  <div
    {...props}
    data-component={component}
    className={cn(ITEM_GROUP_CLASS, className)}
  >
    { children }
  </div>
);

ItemGroup.displayName = "ItemGroup";
